import React from 'react';
import { motion } from 'framer-motion';
import { marketplaces } from '../../data/vendoo';
import { EASE_OUT } from '../../utils/motion';
const BARS = [38, 52, 46, 61, 58, 74, 70, 86];
export function VendooTabletMock() {
  return <div aria-hidden className="grid place-items-center rounded-2xl bg-surface px-4 py-8 md:px-12 md:py-14" data-id="element-659" data-mp="pc6k44dzmrn">
      <div className="w-full max-w-[640px] rounded-[26px] bg-night p-2.5 shadow-xl md:p-3.5" data-id="element-660" data-mp="5n48lqyqwp9k">
        <div className="grid aspect-[4/3] grid-cols-[22%_1fr] overflow-hidden rounded-[16px] bg-white sm:aspect-[16/10]" data-id="element-661" data-mp="347cks10jcodp">
          <div className="flex flex-col gap-2 border-r border-line bg-canvas p-3" data-id="element-662" data-mp="3929nyrb4w3io">
            <div className="mb-2 h-3 w-3/4 rounded-full bg-ink" data-id="element-663" data-mp="3e1mcdghnlind" />
            {['Inventory', 'Listings', 'Analytics', 'Settings'].map((item, i) => <div key={item} className={`truncate rounded-md px-2 py-1.5 text-[9px] font-medium md:text-[10px] ${i === 2 ? 'bg-ink-soft text-ink' : 'text-fg-faint'}`} data-id="element-664" data-mp="2lftijwec5ecq" data-mpi={i}>
                {item}
              </div>)}
          </div>
          <div className="flex flex-col p-3 md:p-4" data-id="element-665" data-mp="17lcn2tf7g8o6">
            <div className="grid grid-cols-3 gap-2" data-id="element-666" data-mp="17mnzfhmpuoqw">
              {[['Sales', '$4,820'], ['Profit', '$2,140'], ['Sold', '63']].map(([label, value]) => <div key={label} className="rounded-lg bg-surface p-2" data-id="element-667" data-mp="tuhm03ay6vv5">
                  <p className="text-[8px] text-fg-faint md:text-[9px]" data-id="element-668" data-mp="tvsqy6g4q9nu">{label}</p>
                  <p className="text-[11px] font-semibold text-fg md:text-sm" data-id="element-669" data-mp="oule3sz4qkab">{value}</p>
                </div>)}
            </div>
            <div className="mt-3 flex flex-1 items-end gap-[5%] rounded-lg border border-line p-3" data-id="element-670" data-mp="ex8fg2d2pliu">
              {BARS.map((h, i) => <motion.div key={i} className={`flex-1 rounded-t ${i === BARS.length - 1 ? 'bg-coral' : 'bg-ink'}`} style={{
              height: `${h}%`,
              originY: 1
            }} initial={{
              scaleY: 0
            }} whileInView={{
              scaleY: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.3,
              ease: EASE_OUT,
              delay: 0.15 + i * 0.04
            }} data-id="element-671" data-mp="2e99sfzra6caz" data-mpi={i} />)}
            </div>
            <div className="mt-3 flex flex-wrap gap-1" data-id="element-672" data-mp="2mg3alj2o6tm">
              {marketplaces.slice(0, 4).map(m => <span key={m} className="rounded-full bg-surface px-2 py-0.5 text-[8px] font-medium text-fg-muted md:text-[9px]" data-id="element-673" data-mp="qcaaonkmh36h">
                  {m}
                </span>)}
            </div>
          </div>
        </div>
      </div>
    </div>;
}